import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GroupInterface } from '../interfaces/group.interface';

@Injectable({
  providedIn: 'root'
})
export class GroupsStore {
  private readonly _groups$: BehaviorSubject<GroupInterface[] | null> = new BehaviorSubject<GroupInterface[] | null>(null);
  private readonly STORAGE_KEY = 'availableGroups';

  private _myGroups$: BehaviorSubject<GroupInterface[] | null>;
  private readonly MY_GROUPS_KEY = 'myGroups';

  constructor() {
    let initialValue = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring BU from sessionStorage', e);
    }
    this._groups$ = new BehaviorSubject<GroupInterface[]|null>(initialValue);

    let myGroupsInitial = null;
    try {
      const stored = sessionStorage.getItem(this.MY_GROUPS_KEY);
      if (stored) {
        myGroupsInitial = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring myGroups from sessionStorage', e);
    }
    this._myGroups$ = new BehaviorSubject<GroupInterface[]|null>(myGroupsInitial);
  }

  get groups$(): Observable<GroupInterface[] | null> {
    return this._groups$.asObservable();
  }

  get groups(): GroupInterface[] | null {
    return this._groups$.getValue();
  }

  set groups(groups: GroupInterface[] | null) {
    if (groups) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(groups));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._groups$.next(groups);
  }

  get myGroups$(): Observable<GroupInterface[] | null> {
    return this._myGroups$.asObservable();
  }

  get myGroups(): GroupInterface[] | null {
    return this._myGroups$.getValue();
  }

  set myGroups(groups: GroupInterface[] | null) {
    if (groups) {
      sessionStorage.setItem(this.MY_GROUPS_KEY, JSON.stringify(groups));
    } else {
      sessionStorage.removeItem(this.MY_GROUPS_KEY);
    }
    this._myGroups$.next(groups);
  }
}
